const MODULE_SHOULD_INIT_FALLBACK = true;

/**
 * Webpack modules lifecycle with performance tracking and logs
 */
export const asyncModule = (module) => ({
  shouldInit(params) {
    return module.shouldInit?.(params) ?? MODULE_SHOULD_INIT_FALLBACK;
  },
  getInit(params) {
    return async (chunk) => {
      await chunk.init(params);
      performance && performance.mark(`asyncJS-done  ${module.name}`);
      console.info(`async loaded : ${module.name}`);
    };
  },
  start() {
    performance && performance.mark(`asyncJS-start ${module.name}`);
  },
  error(error) {
    console.error(`can not load/init ${module.name} : `, error);
  },
});
